export default {
    namespaced: true,
    state: {
		endpoint: 'roles',
		item: {
			id: null,
			users: [],
			services: [],
		},
        items: [],
    },
	actions: {
		clearItem(context) {
			context.commit('item', {
				id: null,
				users: [],
				services: [],
			})
		},
	}
}